import { render, staticRenderFns } from "./predictions.vue?vue&type=template&id=25b4886f&scoped=true&"
import script from "./predictions.vue?vue&type=script&lang=js&"
export * from "./predictions.vue?vue&type=script&lang=js&"
import style0 from "./predictions.vue?vue&type=style&index=0&id=25b4886f&prod&scoped=true&lang=scss&"
import style1 from "./predictions.vue?vue&type=style&index=1&id=25b4886f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b4886f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PredictionsTable: require('/opt/render/project/src/studio-ai/src/components/predictions/PredictionsTable.vue').default})
